import { api } from "./api";

export const deliveryApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getDeliveryRouteDetails: builder.query({
      query: (body) => ({
        url: `/getDeliveryRouteDetails`,
        method: "POST",
        body,
      }),
      providesTags: ["updateSummary"],
    }),

    getDeliveryRouteList: builder.query({
      query: ({ zipCode = "", sku = "" }) =>
        `/website-getDeliveryRouteList?sku=${sku}&zipCode=${zipCode}`,
    }),
  }),
});

export const { useGetDeliveryRouteDetailsQuery, useGetDeliveryRouteListQuery } =
  deliveryApiSlice;
